import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import colors from 'components/PortfolioTables/colors';

const useTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      margin: theme.spacing(4, 0),
      border: 'none',
      borderCollapse: 'collapse',
      fontSize: '9pt',
      textAlign: 'center',
      color: theme.palette.common.black,
      '& th, & td': {
        padding: theme.spacing(1, 2),
        verticalAlign: 'middle',
      },
      '& thead th': {
        fontWeight: 'normal',
        fontSize: '8pt',
        color: theme.palette.grey['600'],
        borderBottom: 'solid #999 1px',
        verticalAlign: 'bottom',
      },
    },
    simple: {
      border: 'solid #333 1px',
      borderCollapse: 'collapse',
      '& thead tr': { textAlign: 'center', background: '#ddd' },
      '& tbody td': { textAlign: 'center', verticalAlign: 'top', padding: '8px' },
      '& th, & td': { border: 'solid #333 1px', background: 'transparent' },
      color: '#000',
    },
    portfolio: {
      fontSize: '8pt',
      '& th, & td': {
        padding: theme.spacing(0, 1),
      },
      '& th:first-child, & td:first-child': {
        width: theme.spacing(2),
        padding: 0,
      },
      '& tr.divider td': {
        borderBottom: 'solid #999 1px',
      },
      '& .IK1': { backgroundColor: colors['IK1'] },
      '& .IK2': { backgroundColor: colors['IK2'] },
      '& .IK3': { backgroundColor: colors['IK3'] },
      '& .IK4': { backgroundColor: colors['IK4'] },
      '& .IK5': { backgroundColor: colors['IK5'] },
      '& tr.total td': {
        paddingTop: theme.spacing(1),
        borderTop: 'solid #000 1px',
        fontWeight: 500,
      },
    },
    currentPortfolio: {
      '& th, & td': {
        padding: theme.spacing(1, 1),
      },
    },
    overview: {
      fontSize: '8pt',
      textAlign: 'left',
      marginTop: theme.spacing(2),
      '& th, & td': {
        padding: theme.spacing(1, 1),
      },
      '& tr:nth-child(even)': {
        backgroundColor: theme.palette.grey['100'],
      },
      '& th:last-child, & td:last-child': {
        textAlign: 'right',
      },
      '& tr.sum td': {
        borderTop: 'solid #000 1px',
        fontWeight: 500,
      },
    },
    transactions: {
      fontSize: '7pt',
      textAlign: 'center',
      '& th:first-child, & td:first-child': {
        width: theme.spacing(2),
        padding: 0,
      },
      '& th:nth-child(2), & td:nth-child(2)': {
        textAlign: 'left',
      },
      '& th, & td': {
        padding: theme.spacing(0.5, 0.5),
      },
      '& .T1': { backgroundColor: theme.palette.grey['300'] },
      '& .T2': { backgroundColor: theme.palette.grey['600'] },
    },
    extProds: {
      fontSize: '8pt',
      textAlign: 'left',
      marginTop: theme.spacing(2),
      '& th, & td': {
        padding: theme.spacing(1, 0.5),
      },
      '& th:last-child, & td:last-child': {
        textAlign: 'right',
      },
      '& tr.summary td': {
        borderTop: 'solid #000 1px',
        fontWeight: 500,
      },
    },
  }),
);

export default useTableStyles;
